import React from 'react';
import { buildPath } from '../Link.jsx';
import * as ROUTES from '../../constants/routes.js';
import './AIChatLink.css';
import { AIChatIcon } from '../icons/AIChatIcon.jsx';

export const AIChatLink = ({
  children = 'AI Assistant',
  beta = true,
  className = '',
  ...props
}) => (
  <a
    href={buildPath(ROUTES.AI_ASSISTANT)}
    target="_blank"
    rel="noopener noreferrer"
    className={`ai-chat-link ${className}`.trim()}
    {...props}
  >
    <AIChatIcon className="ai-chat-link__icon" aria-hidden="true" />
    <span className="ai-chat-link__text">{children}</span>
    {beta && <span className="ai-chat-link__badge">BETA</span>}
  </a>
);
